import { StyleSheet } from "@react-pdf/renderer";

export const rangeStyles = StyleSheet.create({
  container: {
    width: "100pt",
    height: "15pt",
    backgroundColor: "#e3ecfa",
    borderTopLeftRadius: "2pt",
    borderTopRightRadius: "2pt",
    borderBottomRightRadius: "2pt",
    borderBottomLeftRadius: "2pt",
    position: "relative"
  },
  threshold: {
    width: "2pt",
    height: "100%",
    backgroundColor: "#fff",
    position: "absolute"
  },
  bar: {
    height: "15pt",
    backgroundColor: "#446fe5",
    borderTopLeftRadius: "1pt",
    borderTopRightRadius: "1pt",
    borderBottomRightRadius: "1pt",
    borderBottomLeftRadius: "1pt"
  },
  barPale: {
    backgroundColor: "#879fe2"
  }
});

export const demographicStyles = StyleSheet.create({
  card: {
    minHeight: "330pt",
    maxHeight: "330pt",
    overflow: "hidden",
    width: "32%",
    backgroundColor: "#ffffff",
    borderTopLeftRadius: "2pt",
    borderTopRightRadius: "2pt",
    borderBottomRightRadius: "2pt",
    borderBottomLeftRadius: "2pt",
    padding: "12pt",
    marginBottom: "20pt"
  },
  header: {
    display: "flex"
  },
  title: {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14pt",
    textTransform: "uppercase",
    color: "#063ac9"
  },
  line: {
    width: "100%",
    marginTop: "5pt",
    borderBottom: "1pt solid #e3ecfa"
  },
  metricsList: {
    marginTop: "15pt"
  },
  metric: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    marginTop: "8pt"
  },
  metricTitle: {
    width: "100%",
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "12pt",
    color: "#4b5468",
    marginBottom: "3pt"
  },
  metricRange: {
    width: "66%"
  },
  metricValue: {
    width: "26%",
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14pt",
    textAlign: "right",
    color: "#446fe5"
  }
});
